import DictType from "../data/DictType";
import ModuleCenter from "./ModuleCenter";

const createNode = (module, field)=> {
    return {fields:[]};
}

class ModuleNetwork {
    _relations = {};
    _dynamicRelations = {};

    addRelation(srcModule, srcField, destModule, destField, isStatic, isStrong) {
        // console.log('add relation', srcModule, srcField, destModule, destField)
        let moduleInfo = this._relations[srcModule];
        if (!moduleInfo) moduleInfo = this._relations[srcModule] = {};
        let destModuleInfo = moduleInfo[destModule];
        if (!destModuleInfo) destModuleInfo = moduleInfo[destModule] = {relations:[], isStatic:isStatic};
        destModuleInfo.relations.push({src:srcField, dest:destField, isStrong:!!isStrong});
    }
    addDynamicRelation(srcModule, srcField, destModule, destField, isStatic, isStrong) {
        let moduleInfo = this._dynamicRelations[srcModule];
        if (!moduleInfo) moduleInfo = this._dynamicRelations[srcModule] = {};
        let destModuleInfo = moduleInfo[destModule];
        if (!destModuleInfo) destModuleInfo = moduleInfo[destModule] = {relations:[], isStatic:isStatic};
        destModuleInfo.relations.push({src:srcField, dest:destField, isStrong:!!isStrong});
    }

    addRelations(srcModule, srcField, destModule, destField) {
        const sm = ModuleCenter.getModule(srcModule);
        const dm = ModuleCenter.getModule(destModule);
        if (!sm || !dm) return;
        this.addRelation(srcModule, srcField, destModule, destField, dm.getModuleType() == DictType.STATIC, true);
        this.addRelation(destModule, destField, srcModule, srcField, sm.getModuleType() == DictType.STATIC);
    }
    addDynamicRelations(srcModule, srcField, destModule, destField) {
        const sm = ModuleCenter.getModule(srcModule);
        const dm = ModuleCenter.getModule(destModule);
        if (!sm || !dm) return;
        this.addDynamicRelation(srcModule, srcField, destModule, destField, dm.getModuleType() == DictType.STATIC, true);
        this.addDynamicRelation(destModule, destField, srcModule, srcField, sm.getModuleType() == DictType.STATIC);
    }

    clearRelations() {
        this._relations = {};
    }

    testNode(node, module) {
        return node[module] || null;
    }
    getPath(srcModule, destModule, relations, isStrong, src, dest) {
        const path = [];
        for (const relation of relations) {
            if (src && src != relation.src || dest && dest != relation.dest) continue;
            if (isStrong === undefined || relation.isStrong == isStrong) path.push({src:srcModule + '.' + relation.src, dest:destModule + '.' + relation.dest})
        }
        return path.length ? path : null;
    }
    checkModule(srcModule, destModule) {
        const reg = /^(\w+)\.(\w+)$/;

        let srcField = null;
        let destField = null;
        if (reg.test(srcModule)) {
            srcModule = RegExp.$1;
            srcField = RegExp.$2;
        }
        if (reg.test(destModule)) {
            destModule = RegExp.$1;
            destField = RegExp.$2;
        }

        // console.log(this._relations);
        if (srcModule == destModule) {
            const m = ModuleCenter.getModule(srcModule);
            const treeInfo = m._config.treeInfo;
            if (treeInfo) {
                return [[{src:srcModule + '.' + treeInfo.keyField, dest:destModule + '.' + treeInfo.parentField}]];
            }
            return [[{src:srcModule, dest:destModule}]];
        }
        const testMap = {};
        testMap[srcModule] = 1;
        // const node = this._relations[code];
        // 节点和 fields 都要加入 path 里
        const result = [];
        let stack = null;

        // if (!result.length) {
            let first = true;
            stack = [{code:srcModule, path:[]}];
            while (stack.length) {
                const n = stack.shift();
                const node = first ? (this._dynamicRelations[n.code] || this._relations[n.code]) : this._relations[n.code];
                if (this._dynamicRelations[n.code]) first = false;
                if (!node) {
                    // console.log('node', n.code, 'is not exists.')
                } else {
                    let info = null;
                    if (info = this.testNode(node, destModule)) {
                        let p = this.getPath(n.code, destModule, info.relations, undefined, null, destField);
                        if (p) result.push(n.path.concat(p[0]));
                    }
                    for (const [rc, info] of Object.entries(node)) {
                        if (rc == 'sysUser') continue;
                        if (!testMap[rc]) {
                            const p = this.getPath(n.code, rc, info.relations);
                            if (!info.isStatic && n.path.length < 1 && p) {
                                testMap[rc] = 1;
                                stack.push({code:rc, path:n.path.concat(p[0])});
                            }
                        }
                    }
                }
            }
        // }

        // if (!result.length) {
            stack = [{code:srcModule, path:[]}];
            while (stack.length) {
                const n = stack.shift();
                const node = this._relations[n.code];
                if (!node) console.log('node', n.code, 'is not exists.')
                let info = null;
                if (info = this.testNode(node, destModule)) {
                    const p = this.getPath(n.code, destModule, info.relations, undefined, null, destField);
                    if (p) result.push(n.path.concat(p[0]));
                }
                for (const [rc, info] of Object.entries(node)) {
                    if (rc == 'sysUser') continue;
                    if (!testMap[rc]) {
                        const p = this.getPath(n.code, rc, info.relations);
                        if (!info.isStatic && n.path.length < 1 && p) {
                            testMap[rc] = 1;
                            stack.push({code:rc, path:n.path.concat(p[0])});
                        }
                    }
                }
            }
        // }
        if (result.length) {
            result.sort((a, b)=> a.length - b.length);
        }
        return result.length ? result : null;
    }
    testModule(srcModule, destModule) {
        srcModule = ModuleCenter.getModule(srcModule).getRelationCode();
        destModule = ModuleCenter.getModule(destModule).getRelationCode();
        let path = this.checkModule(srcModule, destModule);
        if (path) return path;
        else path = this.checkModule(destModule, srcModule);
        if (path) {
            const res = [];
            for (const p of path) {
                const s = [];
                for (const r of p) {
                    s.unshift({src:r.dest, dest:r.src});
                }
                res.push(s);
            }
            return res;
        }
        
        return null;
    }
    testRelations(path) {
        const rels = [];
        for (let i = 0; i < path.length - 1; i++) {
            let p = this.testModule(path[i], path[i + 1]);
            if (!p || !p.length) return null;
            p = p[0];
            for (const r of p) if (r['src'] != r['dest']) rels.push(r);
        }
        const relPath = [];
        let last = null;
        for (const rel of rels) {
            if (!last) relPath.push(rel);
            else if (last['dest'] == rel['src']) last['dest'] = rel['dest'];
            else relPath.push(rel);
            last = rel;
        }
        return relPath;
    }
    // test(fromModule, fromField, targetModule, targetField) {
        // const moduleInfo = this._relations[fromModule];
        // if (!moduleInfo) return null;
        // if (fromField) {
        //     const fieldInfo = moduleInfo[fromField];
        //     if (!fieldInfo) return null;
        //     const targetModuleInfo = fieldInfo[targetModule];
        //     if (!targetModuleInfo) return null;
        //     if (!targetField) return {module:fromModule, field:fromField};
        //     else return targetModuleInfo[targetField] ? {module:fromModule, field:fromField} : null;
        // } else {
        //     for (const [field, fieldInfo] of Object.entries(moduleInfo)) {
        //         if (!fieldInfo) continue;
        //         const targetModuleInfo = fieldInfo[targetModule];
        //         if (!targetModuleInfo) continue;
        //         if (!targetField) return {module:fromModule, field:fromField};
        //         else if (targetModuleInfo[targetField]) return {module:fromModule, field:fromField};
        //     }
        // }

    // }
}

export default ModuleNetwork;